import {
  Autocomplete,
  TextField,
} from '@xbotvn/mui';
import { find } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

export default function SingleSelect({
  options = [],
  value,
  onChange = () => { },
  placeholder = 'Select option',
  disabled = false,
  InputProps = {},
  clearable = false,
}) {
  const getActiveValue = () => find(options, (option) => option.value === value) || [];

  return (
    <Autocomplete
      disabled={disabled}
      getOptionLabel={(option) => option?.label || ''}
      value={getActiveValue()}
      options={options}
      noOptionsText={placeholder}
      onChange={(e, data) => onChange(data?.value || '')}
      renderInput={(params) => <TextField placeholder={placeholder} {...InputProps} {...params} />}
      fullWidth
      disableClearable={!clearable}
    />
  );
}

SingleSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    label: PropTypes.string.isRequired,
    rightLabel: PropTypes.string,
  })),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  InputProps: PropTypes.shape({}),
  clearable: PropTypes.bool,
};
